var data = {
	"body": "<path d=\"M14 19h4V5h-4M6 19h4V5H6v14z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
